import React, { FC, useEffect, useState } from 'react'
import {
  PageTitleWrapper,
  PageHeader,
} from '../../shared/components/index';
import {
  Grid,
  Container,
  Box,
  Button,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tabs,
  Tab
} from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useTranslation } from 'react-i18next';
import {
  BOOKING_STATUS_ENUM,
  I18N,
  LIST_VIEW,
  REGEX,
  ROLES,
  TENANT_ROLES
} from '../../shared/constants/constants';
import GridViewSharpIcon from '@mui/icons-material/GridViewSharp';
import TableRowsTwoToneIcon from '@mui/icons-material/TableRowsTwoTone';
import AssetDetailsTable from './components/AssetDetailsTable';
import ExpenceManagementTable from '../expence/components/ExpenceManagementTable';
import YearCalendar from 'src/shared/components/fullcalendar/FullCalendar';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

interface AssetDetailsProps {
  handlAssetViewBackClick: (row: any) => void;
  dataSelectedAsset: any;
  inputIsAssetSold: boolean,
  inputBookingAssetData: any[];
  inputAssetExpenceList: any[];
}

const AssetDetails: FC<AssetDetailsProps> = ({
  handlAssetViewBackClick,
  dataSelectedAsset,
  inputBookingAssetData,
  inputAssetExpenceList,
  inputIsAssetSold,
}) => {
  const { t } = useTranslation(I18N.ASSET_MANAGEMENT);

  const [events, setEvents] = useState([]);
  const [tabIndex, setTabIndex] = useState("0");

  useEffect(() => {
    if (inputBookingAssetData) {
      const filteredData = inputBookingAssetData.filter(item => item.bookingStatus !== BOOKING_STATUS_ENUM.CANCELLED); // Filter by status
      const convertedEvents = filteredData.map((item) => ({
        title: `${item.name}`,
        start: item.deliveryDate,
        end: item.returnDate,
        tooltip: `Address: ${item.address}, Mobile: ${item.mobile}`, // Add tooltip data
      }));
      setEvents(convertedEvents);
    } else {
      setEvents([]);
    }
  }, [inputBookingAssetData]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <PageTitleWrapper>
        <PageHeader
        // breadcrumbs={breadcrumbs}
        // heading={breadcrumbsHeading}
        // subHeading={headerSubtitle}
        >
          {/* {viewType == VIEW_TYPE.ASSET_MANAGEMENT && ( */}
          <Button
            size={'small'}
            sx={{ pt: 1, pb: 1 }}
            className="letter-spacing"
            variant={'contained'}
            startIcon={<AddTwoToneIcon fontSize="small" />}
            onClick={handlAssetViewBackClick}
          >
            {t('back')}
          </Button>
          <></>
          {/* )} */}
          {/* <TextField
            size={'small'}
            id="outlined-search"
            // label={t('search-user')}
            type="search"
          // onChange={(e) => handleFilterUsers(e.target.value)}
          /> */}
        </PageHeader>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <TabContext value={tabIndex}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Tab label="Calendar View" value="0" />
              <Tab label="List" value="1" />
            </TabList>
          </Box>
          <TabPanel value="0"><YearCalendar events={events} /></TabPanel>
          <TabPanel value="1">{inputIsAssetSold ? (
            <ExpenceManagementTable
              inputExpenceData={inputAssetExpenceList}
              inputIsAssetSold={inputIsAssetSold}
            />
          ) : (
            <AssetDetailsTable inputBookingAssetData={inputBookingAssetData} />
          )}</TabPanel>
        </TabContext>
      </Container>
    </>
  )
};

export default AssetDetails
